// extracted by mini-css-extract-plugin
module.exports = {"section":"ProposalContent_section__hGx6B","markdown":"ProposalContent_markdown__3dCs8"};